// require('./velocity');
import * as DOMElements from './DOMElements';

const isDebug = window.location.hash === "#debug" || window.location.hash === "debug";

const start_widget = () => {
    const $ = window.jQuery || window.$;
    const chat_container = $(".faq-widget-chat");
    const close_btn = $("#close_widget, .close_widget");
    const close_widget_btn = $(DOMElements.widgetClose);
    const open_btn = $(".open_widget");
    const faq_search_element = $("#faq-searchphrase");

    close_btn.click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).hide();
        $("#chat_invite").remove();
    });

    const get_chat_element = function () {
        return document.getElementById("chat")
    };
    const scroll_something = function () {
        let t, a, e;
        const n = get_chat_element();
        (void 0 === a && (a = 20), !((t = n).scrollTop + t.clientHeight >= t.scrollHeight - a)) && ((e = get_chat_element()).scrollTop = e.scrollHeight)
    };

    open_btn.click(function (e) {
        e.preventDefault();
        $("#faq-searchphrase").focus();
        $(".faq-widget-open").show();
        $(".faq-widget-button").hide();
        open_btn.attr('aria-expanded', 'true');
        close_widget_btn.attr('aria-expanded', 'true');
        scroll_something();
    });

    close_widget_btn.click(function (e) {
        e.preventDefault();
        $(".faq-widget-button").show();
        $(".faq-widget-open").hide();
        $("#open-widget-container").focus();
        open_btn.attr('aria-expanded', 'false');
        close_widget_btn.attr('aria-expanded', 'false');
    });
    $("#faq-form").submit(function (e) {
        e.preventDefault();
    });

    faq_search_element.focusin(function () {
        $(this).parents(".faq-widget-coms").css({"border-color": "#444"})
    });
    faq_search_element.focusout(function () {
        $(this).parents(".faq-widget-coms").css({"border-color": "#e6f1f4"})
    });

    const widget = new function (id, a) {
        const self = this;

        this.id = id;
        this.container = $(`#${id}`);
        this.defaultOptions = {
            menuItemClass: "simple-content-manager__menu-item",
            contentItemClass: "simple-content-manager__content-item",
            backClass: "simple-content-manager__back",
            menuClass: "simple-content-manager__menu",
            activeClass: "active",
            searchAction: "search",
        };
        this.options = function (t, a) {
            var e = {};
            if (void 0 === a) return t;
            for (var n in t) t.hasOwnProperty(n) && (e[n] = a.hasOwnProperty(n) ? a[n] : t[n]);
            return e
        }(this.defaultOptions, a);
        this.menuItems = null;
        this.contentItems = null;
        this.menu = null;
        this.back = null;
        this.searchMenuButton = null;
        this.backToMenu = function () {
            self.menu.removeClass(self.options.activeClass);
            self.menuItems.removeClass(self.options.activeClass);
            self.contentItems.hide();
            self.searchMenuButton.removeAttr('role');
            self.searchMenuButton.removeAttr('tabindex');
            if (isDebug) console.log("backToMenu invoked");
        };
        this.launchContent = function (e) {
            if (isDebug) console.log('launchContent', {e});
            self.menuItems.removeClass(self.options.activeClass);
            self.container.find("." + self.options.menuItemClass).filter('[data-id="' + e + '"]').addClass(self.options.activeClass);
            self.menu.addClass(self.options.activeClass);
            self.searchMenuButton.attr('role', 'button');
            self.searchMenuButton.attr('tabindex', '0');
            self.contentItems.hide();
            self.contentItems.filter('[data-id="' + e + '"]').fadeIn(400, function () {
                scroll_something()
            })
        };
        this.selectSearch = function (e) {
            if (self.menuItems.hasClass(self.options.activeClass)) {
                self.backToMenu();
                setTimeout(() => {
                    DOMElements.searchInput.focus();
                }, 1);
            }
        };
        this.run = function () {
            this.menuItems = this.container.find("." + this.options.menuItemClass);
            this.searchMenuButton = this.container.find(`.${this.options.menuItemClass}[data-id="${this.options.searchAction}"]`);
            this.contentItems = this.container.find("." + this.options.contentItemClass);
            this.menu = this.container.find("." + this.options.menuClass);
            this.back = this.container.find("." + this.options.backClass);
            this.menuItems.click(function (e) {
                e.preventDefault();
                const action = $(this).attr("data-id");
                if (action) {
                    if (action === "search") {
                        self.selectSearch();
                    } else {
                        self.launchContent(action);
                    }
                }
            });
            this.back.click(function (t) {
                t.preventDefault();
                if (isDebug) console.log("back clicked");
                self.backToMenu()
            });
            this.searchMenuButton.on('keydown', (e) => {
                const keyD = e.key !== undefined ? e.key : e.keyCode;
                if ((keyD === 'Enter' || keyD === 13) || (['Spacebar', ' '].indexOf(keyD) >= 0 || keyD === 32)) {
                    const btn = e.target.closest(`.${this.options.menuItemClass}`);
                    if ((btn.getAttribute('role') ?? "").toLowerCase() !== "button") {
                        return;
                    }

                    e.preventDefault();
                    $(btn).click();
                }
            });
        }
    }("faq-window");

    widget.run();
    "undefined" != typeof shouldLivechatBeOpenImmediately && shouldLivechatBeOpenImmediately && setTimeout(function () {
        $("#faq-searchphrase").focus();
        $(".faq-widget-open").show();
        $(".faq-widget-button").hide();
        scroll_something();
        widget.launchContent("talk")
    }, 1e3);
    $(document).on("click", ".nosearch", function () {
        setTimeout(function () {
            chat_container.scrollTop(chat_container[0].scrollHeight)
        }, 100), $(chat_container).append('<div class="faq-widget-chat-message msg-bot"><div class="head"><img src="/templates/clean-bootstrapv2/img/widget/bot.png" alt="Awatar"/><p>Wirtualny<br />konsultant</p></div><div class="message"><p>Czy chcesz porozmawiać z Konsultantem?</p></div></div>'), $(chat_container).append('<div class="faq-window-content faq-window-content--narrower"><div class="horizontal-buttons"><div class="horizontal-buttons__item"><button class="gotoChatButton simple-button" data-q="' + $(this).data("q") + '" class="foundans">Tak</button></div><div class="horizontal-buttons__item"><button class="noWantoToTalk simple-button" data-q="' + $(this).data("q") + '">Nie</button></div></div></div>')
    });
    $(document).on("click", ".foundans", function () {
        $(chat_container).append('<div class="faq-widget-chat-message msg-user"><div class="message"><p>Tak</p></div></div>');
        setTimeout(function () {
            chat_container.scrollTop(chat_container[0].scrollHeight)
        }, 100)
    });
    $(document).on("click", ".noWantoToTalk", function () {
        $(chat_container).append('<div class="faq-widget-chat-message msg-user"><div class="message"><p>Nie</p></div></div>');
        setTimeout(function () {
            chat_container.scrollTop(chat_container[0].scrollHeight)
        }, 100)
    });
    $(document).on("click", ".gotoChatButton", function () {
        widget.launchContent("talk")
    });
    $(document).on("click", ".gotofaqButton", function () {
        window.open("https://faq.parp.gov.pl/?qs=" + $(this).data("q"), "_blank")
    });
    $("input[tabindex]").click(function () {
        if (isDebug) console.log("checkbox clicked")
    });
    $(document).on("click", ".searchall", function () {
        const faq_category_element = $("#faq-category");
        const faq_search_phrase_element = $("#faq-searchphrase");
        var category = faq_category_element.val();
        faq_category_element.val("");
        faq_search_phrase_element.val($(this).data("q"));
        $(this).hide();
        $(this).siblings("button").hide();
        chat_container.append('<div class="faq-widget-chat-message msg-user"><div class="message"><p>Tak</p></div><div class="head"><img src="/templates/clean-bootstrapv2/img/widget/user.png" alt="Awatar"/><p>Ty</p></div></div>');
        setTimeout(function () {
            chat_container.scrollTop(chat_container[0].scrollHeight)
        }, 100);
        $("#faq-form").submit();
        setTimeout(function () {
            $("#faq-category").val(category)
        }, 600);
    });

    // setTimeout(function () {
    //     $(".faq-widget").velocity({opacity: 1, translateZ: 0, translateX: 0}, {duration: 1500})
    // }, 2e3);

    setTimeout(() => {
        $(DOMElements.widget).show('slow');
    }, 500);

}
export {
    start_widget,
}
